import api from '../../../api/_dossier-medical'
import api_exam from '../../../api/_examen'
import api_consultation from '../../../api/_consultation'
import api_protocoles from '../../../api/consultations/_protocole-soins'
import api_infirmier from '../../../api/_infirmier'

export default {
    getPatientLatestConsultation(data) {
        return api_consultation.getPatientLatestConsultation(data)
    },
    getTableauInfirmierAccess() { return api_infirmier.getTableauInfirmierAccess() },
    getTableauInfirmier(data) { return api_infirmier.getTableauInfirmier(data) },
    getFiltresTableauInfirmier(data) { return api_infirmier.getFiltresTableauInfirmier(data) },
    getStatistiquesTableauInfirmier(data) { return api_infirmier.getStatistiquesTableauInfirmier(data) },
    getStatistiquesTableauMedecin(data) {
        return api_consultation.getStatistiquesTableauMedecin(data)
    },
    getClotureMedecinAccess() {
        return api_consultation.getClotureMedecinAccess()
    },
    getClotureContexte(id, token) { return api_consultation.getClotureContexte(id, token) },
    cloturerConsultationMedecin(id, data, token) {
        return api_consultation.cloturerConsultationMedecin(id, data, token)
    },
    getReferenceCatalogue(data) { return api_consultation.getReferenceCatalogue(data) },
    demanderAvisMedical(id, data, token) { return api_consultation.demanderAvisMedical(id, data, token) },
    getAvisMedicalConsultation(id, token) { return api_consultation.getAvisMedicalConsultation(id, token) },
    getAvisMedicauxRecus(token) { return api_consultation.getAvisMedicauxRecus(token) },
    getDossierAvisMedical(id, token) { return api_consultation.getDossierAvisMedical(id, token) },
    repondreAvisMedical(id, data, token) { return api_consultation.repondreAvisMedical(id, data, token) },
    getTableauMedecinAccess() {
        return new Promise((resolve, reject) => {
            api_consultation.getTableauMedecinAccess().then(response => resolve(response), error => reject(error))
        })
    },
    getTableauMedecin(data) {
        return new Promise((resolve, reject) => {
            api_consultation.getTableauMedecin(data).then(response => resolve(response), error => reject(error))
        })
    },
    // RDV-003 : rendez-vous (tableau médecin et tableau infirmier)
    getRendezVousMedecin(data) {
        return new Promise((resolve, reject) => {
            api_consultation.getRendezVousMedecin(data).then(response => resolve(response), error => reject(error))
        })
    },
    // RDV-006 : rendez-vous donné pendant la consultation (heure facultative) ; la Clinique dérive patient, médecin et prestation
    reprogrammerRendezVousMedecin(data) { return api_consultation.reprogrammerRendezVousMedecin(data) },
    donnerRendezVousConsultation(data) {
        return new Promise((resolve, reject) => {
            api_consultation.saveNextRDV(data).then(response => resolve(response), error => reject(error))
        })
    },
    changerStatutRendezVousMedecin(data) {
        return new Promise((resolve, reject) => {
            api_consultation.changerStatutRendezVousMedecin(data).then(response => resolve(response), error => reject(error))
        })
    },
    getRendezVousInfirmier(data) { return api_infirmier.getRendezVousInfirmier(data) },
    getIndicateursRendezVousMedecin(data) { return api_consultation.getIndicateursRendezVousMedecin(data) },   // RDV-005
    getFiltresTableauMedecin(data) {
        return new Promise((resolve, reject) => {
            api_consultation.getFiltresTableauMedecin(data).then(response => resolve(response), error => reject(error))
        })
    },
    ouvrirConsultationTableauMedecin(data) {
        return new Promise((resolve, reject) => {
            api_consultation.ouvrirConsultationTableauMedecin(data).then(response => resolve(response), error => reject(error))
        })
    },
    prendreReferenceTableauMedecin(id, token) { return api_consultation.prendreReferenceTableauMedecin(id, token) },
    getConsultationAnamneses(data) {
        return new Promise((resolve, reject) => {
            api.getConsultationAnamneses(data).then(
                response => {
                    if (data.est_en_cours == true) {
                        resolve(response)
                    } else {
                        resolve(response)
                    }
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getExamensAttenteInterpretation(data) {
        return new Promise((resolve, reject) => {
            api_exam.getExamensAttenteInterpretation(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveExamenInterpretation(data) {
        return new Promise((resolve, reject) => {
            api_exam.saveExamenInterpretation(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getHistoriqueResultatExamen(data) {
        return new Promise((resolve, reject) => {
            api_exam.getHistoriqueResultatExamen(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveClicheExamen(data) {
        return new Promise((resolve, reject) => {
            api_exam.saveClicheExamen(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getConsultationsEnAttente(data) {
        return new Promise((resolve, reject) => {
            api_consultation.getConsultationAttente(data).then(response => {
                resolve(response)
            }, error => {
                reject(error)
            })
        })
    },

    getSuitesSoins(data) {
        return new Promise((resolve, reject) => {
            api_consultation.getSuitesSoins(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getPatientsAdmissionEnCours(data) {
        return new Promise((resolve, reject) => {
            api_protocoles.getPatientsAdmissionEnCours(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTraitementEnCours(data) {
        return new Promise((resolve, reject) => {
            api_protocoles.getTraitementEnCours(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    editProtocoleData(data) {
        return new Promise((resolve, reject) => {
            api_protocoles.editProtocoleData(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteProtocoleItem(data) {
        return new Promise((resolve, reject) => {
            api_protocoles.deleteProtocoleItem(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}
